import React from 'react';
import ReactDOM from 'react-dom/client';
import { Capacitor } from '@capacitor/core';
import App from './App';

// Suppress page-level reload/navigation on native.
//
// Clerk's JS SDK calls window.location.reload() (and sometimes sets
// window.location.href) as part of its web-oriented session management
// (e.g. in setActive, __internal_reloadInitialResources). On native the
// Capacitor WebView has no cookies / browser session, so these reloads
// destroy the JS context and restart from scratch — creating an infinite
// reload loop after sign-in.
//
// On native, Clerk session state is managed entirely by the native Clerk
// iOS SDK via capacitor-clerk; React Router handles all client-side
// navigation. A full-page reload is never correct here.
if (Capacitor.isNativePlatform()) {
  try {
    window.location.reload = () => {
      console.log('[native] Suppressed window.location.reload()');
    };
  } catch {
    // read-only in some environments — ignore
  }
}

// Variable-axis fonts. Inter for body, Fraunces for display serif.
// Bundled locally so the app stays offline-safe in Capacitor.
import '@fontsource-variable/inter/index.css';
// `full.css` enables the opsz + SOFT + WONK axes (referenced in index.css
// via `font-variation-settings`). `index.css` would only load the weight axis.
import '@fontsource-variable/fraunces/full.css';

import './index.css';
import './styles/template-system.css';
import './styles/deficiency-library.css';
import './styles/report-editor.css';

// Register service worker for PWA
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').then(
      (registration) => {
        console.log('ServiceWorker registration successful:', registration.scope);
      },
      (error) => {
        console.log('ServiceWorker registration failed:', error);
      }
    );
  });
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
